import { ClipboardCopyBtn } from 'src/libs/useful'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'

 
const Id = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props }
        desabledForm={<IdDisabled {...props} />}
    />
} 
export default Id 
 
 
export const IdDisabled = ( props: IScalarForm ): JSX.Element => { 
    return <div className='d-flex align-items-center w-100'>
        <pre className='px-3 py-1 bg-contrast-secondary-opacity border1 border-force-secondary-opacity my-1 ml-1 mr-auto text-overflow '>
            <code>
                { props.value }
            </code>
        </pre>
        <ClipboardCopyBtn data={props.value} type="button" label="Copy" />
    </div>
}